"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlVec4Uniform = void 0;
const a_gl_uniform_array_1 = require("./a-gl-uniform-array");
/**
 * @public
 * Wrapper for webgl float vector4 uniform.
 */
class GlVec4Uniform extends a_gl_uniform_array_1.AGlUniformArray {
    bind(renderer) {
        if (!this.isDirty) {
            return;
        }
        const data = this.data;
        renderer.context.uniform4fv(this.uniformLocation, data);
        this.isDirty = false;
    }
}
exports.GlVec4Uniform = GlVec4Uniform;
//# sourceMappingURL=gl-vec4-uniform.js.map